export default __webpack_public_path__ + "media/images/21-b3b1e65b5268f7241dfbda35bd727342.jpg";